import React from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageToggleProps {
  className?: string;
}

/**
 * Language toggle component for switching between English and French.
 * Displays as a pill-shaped toggle button in the header.
 */
export const LanguageToggle: React.FC<LanguageToggleProps> = ({ className = '' }) => {
  const { i18n } = useTranslation();
  
  const currentLanguage = i18n.language?.substring(0, 2) || 'en';
  const isEnglish = currentLanguage === 'en';
  const isFrench = currentLanguage === 'fr';

  const toggleLanguage = () => {
    const newLang = isEnglish ? 'fr' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className={`flex items-center rounded-full overflow-hidden border border-gray-300 hover:border-gray-400 transition-colors ${className}`}
      title={isEnglish ? 'Switch to French / Passer au français' : 'Switch to English / Passer à l\'anglais'}
      aria-label={`Current language: ${isEnglish ? 'English' : 'French'}. Click to switch.`}
    >
      <span
        className={`px-2 py-1 text-xs font-bold transition-colors ${
          isEnglish 
            ? 'bg-blue-600 text-white' 
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        EN
      </span>
      <span
        className={`px-2 py-1 text-xs font-bold transition-colors ${
          isFrench 
            ? 'bg-blue-600 text-white' 
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        FR
      </span>
    </button>
  );
};

export default LanguageToggle;

